import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import useFetchPost from "../hooks/useFetchPost";
import ChangePassword from "../modals/ChangePassword";
import Confirm from "../modals/Confirm";
import ManageMuviOwnership from "../modals/ManageMuviOwnership";
import RaiseCustomInvoice from "../modals/RaiseCustomInvoice";
import ExtendFreeTrial from "../modals/ExtendFreeTrial";
import ManageDemoAccount from "../modals/ManageDemoAccount";
import CancelAccount from "../modals/CancelAccount";
import ManageDemoAccountMuvi5 from "../modals/ManageDemoAccountMuvi5";
import DeleteModal from "../modals/DeleteModal";
import RestoreModal from "../modals/RestoreModal";
import ExtendedTrailPeriodModal from "../modals/ExtendedTrailPeriodModal";
import Subscription from "../modals/Subscription";
import { maskEmail } from "../customer/Utility";
import Avatar from "rsuite/Avatar";
import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const crmUsersLists = [
	"name",
	"email",
	"phone_number",
	"company_name",
	"role",
	"address",
	"country_code",
	"country_name",
	"state",
	"city",
	"zip_code",
	"ip_address",
	"logo",
	"domain",
	"source",
];

const TableList = ({
	data,
	loading,
	totalCount,
	columndata = [],
	setApiRun,
	currentPage,
	isLive,
	productData,
	crmUserFilterKeyLists,
	muviUserId,
	accountManagerData,
	salesManagerData,
	tseOwnerData,
}) => {
	// console.log(usersData, "userData");
	// console.log(usersData.isAccountManagerLoading, "user");
	const { fetchPostData, error } = useFetchPost();
	const [crmPermission, setCrmPermission] = useState(localStorage.getItem("crm_permission"));
	const [storePermission, setStorePermission] = useState(localStorage.getItem("store_permission"));
	const [isGeneralUser, setIsGeneralUser] = useState(localStorage.getItem("is_general_user"));
	const [customerSuccessPermission, setCustomerSuccessPermission] = useState(
		localStorage.getItem("customer_success_permission")
	);
	const [confirmModalData, setConfirmModalData] = useState(null);
	const [muviOwnershipModalData, setMuviOwnershipModalData] = useState(null);
	const [raiseCustomInvoiceModalData, setRaiseCustomInvoiceModalData] = useState(null);
	const [extendedFreeTrailModalData, setExtendedFreeTrailModalData] = useState(null);

	const [manageDemoAccountModalData, setManageDemoAccountModalData] = useState(null);

	const [changePasswordModalData, setChangePasswordModalData] = useState(null);
	const [cancelAccountModalData, setCancelAccountModalData] = useState(null);
	const [manageDemoAccountMuvi5ModalData, setManageDemoAccountMuvi5ModalData] = useState(null);
	const [deleteModalData, setDeleteModalData] = useState(null);
	const [restoreModalData, setRestoreModalData] = useState(null);
	const [extendedTrailPeriodModalData, setExtendedTrailPeriodModalData] = useState(null);
	const [subscriptionModalData, setSubscriptionModalData] = useState(null);

	/**
	/**
	 * Formats the value based on the attribute type of the item.
	 * @param {any} value - The value to be formatted.
	 * @param {object} item - The item containing attribute information.
	 * @param {string} item.attribute_type - The type of attribute (e.g., "text", "api", "date").
	 * @param {object[]} item.options - The options for the attribute (for "api" type).
	 * @param {string} item.field - The field name (used for conditional rendering).
	 * @returns {string | JSX.Element} The formatted value or JSX element.
	 */
	function getMuviOwnerShip(value, account_type) {
		let muviOwnershipUser = {};
		if (account_type == "account_manager") {
			const result = accountManagerData.filter((item) => item.user_uuid === value);
			muviOwnershipUser.attachment = result.length > 0 ? result[0].attachment : `-NA-`;
			muviOwnershipUser.name = result.length > 0 ? result[0].name : "";
			muviOwnershipUser.id = result.length > 0 ? result[0].id : "";
		} else if (account_type == "sales_manager") {
			const result2 = salesManagerData.filter((item) => item.user_uuid === value);
			muviOwnershipUser.attachment = result2.length > 0 ? result2[0].attachment : `-NA-`;
			muviOwnershipUser.name = result2.length > 0 ? result2[0].name : "";
			muviOwnershipUser.id = result2.length > 0 ? result2[0].id : "";
		} else if (account_type == "tse_owner") {
			const result3 = tseOwnerData.filter((item) => item.user_uuid === value);
			muviOwnershipUser.attachment = result3.length > 0 ? result3[0].attachment : "-NA-";
			muviOwnershipUser.name = result3.length > 0 ? result3[0].name : "";
			muviOwnershipUser.id = result3.length > 0 ? result3[0].id : "";
		}
		return muviOwnershipUser;
	}
	function isValidUrl(string) {
		const regex = /^(https?:\/\/)?(www\.)?[^\s/$.?#]+\.[^\s/$.?#]+(\/.*)?$/;
		return regex.test(string);
	}
	const checkFieldNameWithReturnValue = (fieldName, value) => {
		if (crmUserFilterKeyLists.includes(fieldName)) {
			if (crmPermission == 0 && (fieldName == "phone_number" || fieldName == "email")) {
				const fieldValue =
					value.customer && value.customer[fieldName] !== undefined && value.customer[fieldName] !== ""
						? value.customer[fieldName]
						: "-NA-";

				return maskEmail(fieldValue, 4, fieldName);
			} else if (fieldName == "account_manager" || fieldName == "sales_manager" || fieldName == "tse_owner") {
				return value.customer &&
					value.customer[fieldName] !== undefined &&
					value.customer[fieldName] !== "" &&
					value.customer[fieldName] != null
					? getMuviOwnerShip(value.customer[fieldName], fieldName)
					: "-NA-";
			} else {
				return value.customer && value.customer[fieldName] !== undefined && value.customer[fieldName] !== ""
					? value.customer[fieldName]
					: "-NA-";
			}
		} else {
			return value[fieldName] !== undefined && value[fieldName] !== "" ? value[fieldName] : "-NA-";
		}
	};
	const checkAttributeTypeDataFormatting = (value, item) => {
		// console.log(item, " Value ", value);
		//const options = item.options;
		switch (item.attribute_type) {
			case "text":
				if (item.field == "company_name") {
					let detailsUrl;
					if (isLive) {
						if (value.product_key == "49F37046FCD84520895FC18A4F5BFC8B") {
							detailsUrl = `/customer/prod/${value["customer_id"]}`;
						} else {
							detailsUrl = `/customer/prodc/${value["customer_id"]}`;
						}
					} else {
						detailsUrl = `/account/${value["customer_id"]}`;
					}
					return (
						<NavLink
							to={{
								pathname: detailsUrl,
								state: { pageNumber: currentPage },
							}}
							className="company-link"
						>
							<img
								src={value.customer && value.customer["logo"]}
								alt="Logo"
								className="user-image rounded"
								style={{
									width: "30px",
									height: "30px",
									borderRadius: "50%",
									marginRight: "5px",
									objectFit: "contain",
								}}
							/>
							&nbsp;
							{/* {checkFieldNameWithReturnValue(item.field, value)} */}
							<span
								data-toggle="tooltip"
								data-placement="right"
								title={checkFieldNameWithReturnValue(item.field, value)}
							>
								{checkFieldNameWithReturnValue(item.field, value)}
							</span>
						</NavLink>
					);
				} else if (item.field == "source") {
					if (value[item.field] == "" || value[item.field] == "NA") {
						return checkFieldNameWithReturnValue(item.field, value);
					} else {
						if (isValidUrl(checkFieldNameWithReturnValue(item.field, value))) {
							return (
								// <NavLink
								// 	to={`${checkFieldNameWithReturnValue(
								// 		item.field,
								// 		value
								// 	)}`}
								// 	className="source-link"
								// >
								// 	{checkFieldNameWithReturnValue(
								// 		item.field,
								// 		value
								// 	)}
								// </NavLink>
								<a href={checkFieldNameWithReturnValue(item.field, value)} className="source-link">
									{checkFieldNameWithReturnValue(item.field, value)}
								</a>
							);
						} else {
							return checkFieldNameWithReturnValue(item.field, value);
						}
					}
				} else if (item.field == "domain") {
					if (value.customer && (value.customer[item.field] == "" || value.customer[item.field] == "NA")) {
						return checkFieldNameWithReturnValue(item.field, value);
					} else {
						return (
							<a
								href={`http://${checkFieldNameWithReturnValue(item.field, value)}`}
								className="source-link"
								target="_blank"
							>
								{/* {checkFieldNameWithReturnValue(item.field, value)} */}
								<span
									data-toggle="tooltip"
									data-placement="right"
									title={checkFieldNameWithReturnValue(item.field, value)}
								>
									{checkFieldNameWithReturnValue(item.field, value)}
								</span>
							</a>
						);
					}
				} else if (
					item.field == "account_manager" ||
					item.field == "sales_manager" ||
					item.field == "tse_owner"
				) {
					const ownershipUser = checkFieldNameWithReturnValue(item.field, value);
					return ownershipUser !== "-NA-" ? (
						<NavLink
							to={{
								pathname: `/viewEmployee/${ownershipUser.id}`,
							}}
							className="company-link"
							style={{ display: "flex" }}
						>
							{/* <Avatar
								src={ownershipUser.attachment} // Use the variable here
								size="xs"
								circle
								style={{ marginRight: 10 }}
							/> */}
							<img
								src={ownershipUser.attachment}
								alt="Logo"
								className="user-image rounded"
								style={{
									width: "30px",
									height: "30px",
									borderRadius: "50%",
									marginRight: "5px",
									objectFit: "contain",
								}}
							/>
							&nbsp;
							<span
								data-toggle="tooltip"
								data-placement="right"
								title={ownershipUser.name}
								style={{ overflow: "hidden", textOverflow: "ellipsis" }}
							>
								{ownershipUser.name}
							</span>
						</NavLink>
					) : (
						"-NA-"
					); // Return '-NA-' if the condition is not met
				} else {
					//console.log(item.field, "Field Name");
					//return checkFieldNameWithReturnValue(item.field, value);
					return (
						<span
							data-toggle="tooltip"
							data-placement="right"
							title={checkFieldNameWithReturnValue(item.field, value)}
						>
							{checkFieldNameWithReturnValue(item.field, value)}
						</span>
					);
				}

				//return value[item.field] || "-NA-";
				break;
			case "api":
				const option = productData && productData.find((option) => option.product_key === value[item.field]);
				const showValue = option ? option.product_name : "-NA-";
				if (item.field == "product_key") {
					return showValue;
				} else {
					return showValue;
				}
				break;
			case "customer_type":
				return value[item.field] || "-NA-";
				break;
			case "date":
				return checkFieldNameWithReturnValue(item.field, value) != "-NA-" &&
					checkFieldNameWithReturnValue(item.field, value) != "NA" &&
					checkFieldNameWithReturnValue(item.field, value) !== undefined &&
					checkFieldNameWithReturnValue(item.field, value) !== false
					? new Date(checkFieldNameWithReturnValue(item.field, value) * 1000).toLocaleDateString("en-US", {
							year: "numeric",
							month: "short",
							day: "numeric",
					  })
					: "-NA-";

				break;
			case "email":
				//return checkFieldNameWithReturnValue(item.field, value);
				return (
					<span
						data-toggle="tooltip"
						data-placement="right"
						title={checkFieldNameWithReturnValue(item.field, value)}
					>
						{checkFieldNameWithReturnValue(item.field, value)}
					</span>
				);
				break;
			case "tel":
				return checkFieldNameWithReturnValue(item.field, value);
				break;
			case "textarea":
				return checkFieldNameWithReturnValue(item.field, value);
				break;

			default:
				return checkFieldNameWithReturnValue(item.field, value);
		}
	};

	//CTA Related Work Start
	/**
	 * Handle Auto Login
	 * @param {*} confirmText 
	 * @param {*} product_key 
	 * @param {*} user_uuid 

	 */

	const handleClickConfirmModal = (confirmText, product_key, user_uuid) => {
		setConfirmModalData({
			confirmText,
			product_key,
			user_uuid,
			muviUserId,
		});

		const confirmModal = document.getElementById("confirmModal");
		// Open the modal
		confirmModal.classList.add("show");
		confirmModal.style.display = "block";
	};

	const handleClickConfirmModalMuviClassic = (confirmText, value) => {
		const product_key = value["product_key"];
		const customer_user_uuid = value["customer_id"];
		const studioUrl = value.customer["enterprise_api_gateway_url"];
		const email = value.customer["email"];
		const studio_id = value.customer["customer_id"];
		const password = value.customer["encrypted_password"];
		const isMuvi5 = true;
		setConfirmModalData({
			confirmText,
			product_key,
			customer_user_uuid,
			isMuvi5,
			studioUrl,
			email,
			studio_id,
			password,
			muviUserId,
		});

		const confirmModal = document.getElementById("confirmModal");
		// Open the modal
		confirmModal.classList.add("show");
		confirmModal.style.display = "block";
	};

	const handleClickManageMuviOwnershipModal = ({ product_key, customer }) => {
		const { customer_id, account_manager, sales_manager, tse_owner } = customer;
		setMuviOwnershipModalData({
			product_key,
			customer_id,
			account_manager,
			sales_manager,
			tse_owner,
			isLive,
		});
		///$("#manageMuviOwnership").modal("show");

		const manageMuviOwnership = document.getElementById("manageMuviOwnership");
		// Open the modal
		manageMuviOwnership.classList.add("show");
		manageMuviOwnership.style.display = "block";
	};

	const handleClickRaiseCustomInvoiceModal = ({ product_key, customer }) => {
		const { customer_user_uuid, enterprise_api_gateway_url, customer_id } = customer;
		setRaiseCustomInvoiceModalData({
			product_key,
			customer_user_uuid,
			enterprise_api_gateway_url,
			customer_id,
		});
		const raiseCustomInvoice = document.getElementById("raiseCustomInvoice");
		// Open the modal
		raiseCustomInvoice.classList.add("show");
		raiseCustomInvoice.style.display = "block";
	};
	const handleClickExtendFreeTrialModal = ({ product_key, free_trial_expiry_date, customer }) => {
		const { customer_user_uuid, customer_id, store_key, company_name } = customer;
		setExtendedFreeTrailModalData({
			product_key,
			customer_user_uuid,
			customer_id,
			store_key,
			free_trial_expiry_date,
			company_name,
			isLive,
		});
		const extendFreeTrial = document.getElementById("extendFreeTrial");
		// Open the modal
		extendFreeTrial.classList.add("show");
		extendFreeTrial.style.display = "block";
	};

	const handleConfirmToManageDemoAccount = async (
		confirmText,
		product_key,
		user_uuid,
		customer_id,
		store_key,
		is_demo
	) => {
		setManageDemoAccountModalData({
			confirmText,
			product_key,
			user_uuid,
			customer_id,
			store_key,
			is_demo,
			isLive,
		});
		const manageDemoAccountModal = document.getElementById("manageDemoAccountModal");
		// Open the modal
		manageDemoAccountModal.classList.add("show");
		manageDemoAccountModal.style.display = "block";
	};

	// Muvi 5
	const handleClickChangePasswordModal = ({ product_key, customer }) => {
		const { customer_id, customer_user_uuid } = customer;
		setChangePasswordModalData({
			product_key,
			customer_id,
			customer_user_uuid,
		});
		const changePassword = document.getElementById("changePassword");
		// Open the modal
		changePassword.classList.add("show");
		changePassword.style.display = "block";
	};
	const handleClickCancelAccountModal = ({ product, customer }) => {
		const { customer_id, customer_user_uuid, company_name } = customer;
		setCancelAccountModalData({
			product,
			customer_id,
			customer_user_uuid,
			company_name,
			isLive,
		});
		const cancelAccount = document.getElementById("cancelAccount");
		// Open the modal
		cancelAccount.classList.add("show");
		cancelAccount.style.display = "block";
	};

	const handleConfirmManageDemoMuvi5 = async (confirmText, product_key, customer_id, is_demo) => {
		setManageDemoAccountMuvi5ModalData({
			confirmText,
			product_key,
			customer_id,
			is_demo,
			isLive,
		});
		const manageDemoAccountClassicModal = document.getElementById("manageDemoAccountClassicModal");
		// Open the modal
		if (manageDemoAccountClassicModal) {
			manageDemoAccountClassicModal.classList.add("show");
			manageDemoAccountClassicModal.style.display = "block";
		}
	};
	const handleClickDeleteModal = (confirmText, product, customer_id, user_uuid) => {
		setDeleteModalData({
			confirmText,
			product,
			customer_id,
			user_uuid,
			isLive,
		});
		const deleteModal = document.getElementById("deleteModal");
		// Open the modal
		deleteModal.classList.add("show");
		deleteModal.style.display = "block";
	};

	const handleClickRestoreModal = ({ canceled_date, customer }) => {
		const { customer_id, company_name } = customer;
		setRestoreModalData({
			customer_id,
			canceled_date,
			company_name,
		});
		const restoreModal = document.getElementById("restoreModal");
		// Open the modal
		restoreModal.classList.add("show");
		restoreModal.style.display = "block";
	};
	const handleClickExtendTrialPeriodModal = ({ canceled_date, customer }) => {
		const { customer_id, company_name } = customer;
		setExtendedTrailPeriodModalData({
			customer_id,
			canceled_date,
			company_name,
		});
		const extendedTrailPeriodModal = document.getElementById("extendedTrailPeriodModal");
		// Open the modal
		extendedTrailPeriodModal.classList.add("show");
		extendedTrailPeriodModal.style.display = "block";
	};

	const handleClickSubscriptionModal = async ({ customer }) => {
		const { customer_id, customer_user_uuid } = customer;
		setSubscriptionModalData({
			customer_id,
			customer_user_uuid,
		});
		//console.log(customer_id, customer_user_uuid, "data...");

		const subscriptionModal = document.getElementById("subscriptionModal");
		// Open the modal
		subscriptionModal.classList.add("show");
		subscriptionModal.style.display = "block";
	};

	//CTA Related Work End
	/**
	 * Renders action column data based on the provided value object.
	 * @param {object} value - The value object containing product and customer_type information.
	 * @returns {JSX.Element} The JSX representing the action column data.
	 */

	const showActionColumnData = (value) => {
		// console.log(storePermission, "store_permission");
		// console.log(value["customer_type"], "value");
		let menuItems = [];

		if (value["product_key"] === "49F37046FCD84520895FC18A4F5BFC8B") {
			if (storePermission == 1) {
				if (value["customer_type"] === "customer") {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModalMuviClassic(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#manageMuviOwnership"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickManageMuviOwnershipModal(value)}
						>
							Manage Muvi Ownership
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#changePassword"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickChangePasswordModal(value)}
						>
							Change Password
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#cancelAccount"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickCancelAccountModal(value)}
						>
							Cancel Account
						</li>
					);
				} else if (value["customer_type"] === "demo") {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModalMuviClassic(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#manageMuviOwnership"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickManageMuviOwnershipModal(value)}
						>
							Manage Muvi Ownership
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#manageDemoAccountClassicModal"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() =>
								handleConfirmManageDemoMuvi5(
									`Are you sure you want to remove '${value.customer.company_name}' account to demo studio?`,
									value.product_key,
									value.customer.customer_id,
									false
								)
							}
						>
							Remove From Demo
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#cancelAccount"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickCancelAccountModal(value)}
						>
							Cancel Account
						</li>
					);
				} else if (value["customer_type"] === "lead") {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModalMuviClassic(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#manageMuviOwnership"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickManageMuviOwnershipModal(value)}
						>
							Manage Muvi Ownership
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#changePassword"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickChangePasswordModal(value)}
						>
							Change Password
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#manageDemoAccountClassicModal"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() =>
								handleConfirmManageDemoMuvi5(
									`Are you sure you want to move '${value.customer.company_name}' account to demo studio?`,
									value.product_key,
									value.customer.customer_id,
									true
								)
							}
						>
							Move to Demo
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#cancelAccount"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickCancelAccountModal(value)}
						>
							Cancel Account
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#extendedTrailPeriodModal"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickExtendTrialPeriodModal(value)}
						>
							Extend Free Trail
						</li>
					);
				} else if (value["customer_type"] === "cancelled") {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModalMuviClassic(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#manageMuviOwnership"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickManageMuviOwnershipModal(value)}
						>
							Manage Muvi Ownership
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#restoreModal"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickRestoreModal(value)}
						>
							Restore
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#deleteModal"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() =>
								handleClickDeleteModal(
									`Are you sure you want to delete account '${value.customer.company_name}'?`,
									value.product_key,
									value.customer.customer_id,
									value.customer_user_uuid
								)
							}
						>
							Delete
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#subscriptionModal"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickSubscriptionModal(value)}
						>
							Subscription Link
						</li>
					);
				} else {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModalMuviClassic(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>
					);
				}
			} else {
				menuItems.push(
					<li
						className="list-group-item"
						data-toggle="modal"
						data-target="#confirmModal"
						onClick={() =>
							handleClickConfirmModalMuviClassic(
								`Are you sure to login this store '${value.customer.company_name}'?`,
								value
							)
						}
						data-keyboard="false"
						data-backdrop="static"
					>
						Login To Account
					</li>
				);
			}
		} else {
			// Muvi 6
			if (storePermission == 1) {
				if (value["customer_type"] === "customer") {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModal(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value.product_key,
									value.customer.customer_user_uuid
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>,
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#manageMuviOwnership"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickManageMuviOwnershipModal(value)}
						>
							Manage Muvi Ownership
						</li>
						// <li
						// 	className="list-group-item"
						// 	data-toggle="modal"
						// 	data-target="#raiseCustomInvoice"
						// 	data-keyboard="false"
						// 	data-backdrop="static"
						// 	onClick={() => handleClickRaiseCustomInvoiceModal(value)}
						// >
						// 	Raise Custom Invoice
						// </li>
					);
				} else if (value["customer_type"] === "lead") {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModal(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value.product_key,
									value.customer.customer_user_uuid
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>,
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#manageMuviOwnership"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickManageMuviOwnershipModal(value)}
						>
							Manage Muvi Ownership
						</li>,
						<li
							class="list-group-item"
							manageDemoAccountModal
							data-toggle="modal"
							data-target="#manageDemoAccountModal"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() =>
								handleConfirmToManageDemoAccount(
									`Are you sure you want to move '${value.customer.company_name}' account to demo studio?`,
									value.product_key,
									value.customer.customer_user_uuid,
									value.customer.customer_id,
									value.customer.store_key,
									true
								)
							}
						>
							Move to demo
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#extendFreeTrial"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickExtendFreeTrialModal(value)}
						>
							Extend Free Trial
						</li>
						// <li
						// 	class="list-group-item"
						// 	data-toggle="modal"
						// 	data-target="#raiseCustomInvoice"
						// 	data-keyboard="false"
						// 	data-backdrop="static"
						// 	onClick={() => handleClickRaiseCustomInvoiceModal(value)}
						// >
						// 	Raise custom Invoice
						// </li>
					);
				} else if (value["customer_type"] === "demo") {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModal(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value.product_key,
									value.customer.customer_user_uuid
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>,
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#manageMuviOwnership"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickManageMuviOwnershipModal(value)}
						>
							Manage Muvi Ownership
						</li>,
						<li
							class="list-group-item"
							data-toggle="modal"
							data-target="#manageDemoAccountModal"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() =>
								handleConfirmToManageDemoAccount(
									`Are you sure you want to remove '${value.customer.company_name}' account to demo studio?`,
									value.product_key,
									value.customer.customer_user_uuid,
									value.customer.customer_id,
									value.customer.store_key,
									false
								)
							}
						>
							Remove From Demo
						</li>
					);
				} else if (value["customer_type"] === "cancelled") {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModal(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value.product_key,
									value.customer.customer_user_uuid
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>,
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#manageMuviOwnership"
							data-keyboard="false"
							data-backdrop="static"
							onClick={() => handleClickManageMuviOwnershipModal(value)}
						>
							Manage Muvi Ownership
						</li>
					);
				} else {
					menuItems.push(
						<li
							className="list-group-item"
							data-toggle="modal"
							data-target="#confirmModal"
							onClick={() =>
								handleClickConfirmModal(
									`Are you sure to login this store '${value.customer.company_name}'?`,
									value.product_key,
									value.customer.customer_user_uuid
								)
							}
							data-keyboard="false"
							data-backdrop="static"
						>
							Login To Account
						</li>
					);
				}
			} else {
				menuItems.push(
					<li
						className="list-group-item"
						data-toggle="modal"
						data-target="#confirmModal"
						onClick={() =>
							handleClickConfirmModal(
								`Are you sure to login this store '${value.customer.company_name}'?`,
								value.product_key,
								value.customer.customer_user_uuid
							)
						}
						data-keyboard="false"
						data-backdrop="static"
					>
						Login To Account
					</li>
				);
			}
		}

		return (
			<ul class="dropdown-menu list-group dropdownMenuItems" aria-labelledby="dropdownMenu2">
				{menuItems.map((menuItem, index) => (
					<span key={index}>{menuItem}</span>
				))}
			</ul>
		);
	};

	if (loading) {
		return (
			<tbody>
				<tr>
					<div className="row" style={{ width: window.innerWidth - 210 }}>
						<div className="loader-new"></div>
					</div>
				</tr>
			</tbody>
		);
	} else {
		if (totalCount == 0) {
			return (
				<tr>
					<div className="row" style={{ width: window.innerWidth - 210 }}>
						<div
							style={{
								height: "350px",
								width: "100%",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								flexDirection: "column",
							}}
						>
							<svg
								width="56"
								height="56"
								viewBox="0 0 56 56"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clip-path="url(#clip0_504_30600)">
									<path
										d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
										fill="#EFF6FE"
									></path>
									<path d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z" fill="white"></path>
									<path
										d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
										fill="#E2EAF3"
									></path>
									<path d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z" fill="white"></path>
									<path
										d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
										fill="#E2EAF3"
									></path>
									<path
										d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z"
										fill="#7AADF0"
									></path>
									<path
										d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
										fill="#B5DEFF"
									></path>
								</g>
								<defs>
									<clipPath id="clip0_504_30600">
										<rect width="56" height="56" fill="white"></rect>
									</clipPath>
								</defs>
							</svg>
							<div class="mt-3">No Data found</div>
						</div>
					</div>
				</tr>
			);
		}
	}

	return (
		<tbody>
			{/* {loading ? (
				<tr>
					<div className="row" style={{ width: window.innerWidth - 210 }}>
						<div className="loader-new"></div>
					</div>
				</tr>
			) : (
				
			)} */}
			{data.map((value) => (
				<tr key={value.field}>
					{/* Ensure each element has a unique key */}
					{Array.isArray(columndata) &&
						columndata.map((item, index) => (
							<td
								className={item.field}
								key={index}
								style={{
									width: "100%",
									whiteSpace: "nowrap",
									overflow: "hidden",
									textOverflow: "ellipsis",
								}}
							>
								{checkAttributeTypeDataFormatting(value, item)}
							</td>
						))}
					{Array.isArray(columndata) && columndata.length > 0 && value["customer_type"] != "deleted" && (
						<td className="text-center fixed-col">
							{/* Using ternary operator for conditional rendering */}
							{isGeneralUser != 1 ? (
								<div class="dropdown">
									<button
										class="btn btn-default dropdown-toggle"
										type="button"
										id="dropdownMenu2"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
										style={{ margin: "12px -13px" }}
									>
										<svg
											width="30"
											height="30"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M7.99992 8.66668C8.36811 8.66668 8.66659 8.3682 8.66659 8.00001C8.66659 7.63182 8.36811 7.33334 7.99992 7.33334C7.63173 7.33334 7.33325 7.63182 7.33325 8.00001C7.33325 8.3682 7.63173 8.66668 7.99992 8.66668Z"
												fill="#373945"
												stroke="#373945"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M7.99992 3.99999C8.36811 3.99999 8.66659 3.70151 8.66659 3.33332C8.66659 2.96513 8.36811 2.66666 7.99992 2.66666C7.63173 2.66666 7.33325 2.96513 7.33325 3.33332C7.33325 3.70151 7.63173 3.99999 7.99992 3.99999Z"
												fill="#373945"
												stroke="#373945"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M7.99992 13.3333C8.36811 13.3333 8.66659 13.0349 8.66659 12.6667C8.66659 12.2985 8.36811 12 7.99992 12C7.63173 12 7.33325 12.2985 7.33325 12.6667C7.33325 13.0349 7.63173 13.3333 7.99992 13.3333Z"
												fill="#373945"
												stroke="#373945"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</button>
									{showActionColumnData(value)}
								</div>
							) : (
								""
							)}
						</td>
					)}
				</tr>
			))}
			{/*CTA Modals */}
			<Confirm data={confirmModalData} />
			<ManageMuviOwnership data={muviOwnershipModalData} setApiRun={setApiRun} />
			<RaiseCustomInvoice data={raiseCustomInvoiceModalData} setApiRun={setApiRun} />
			<ExtendFreeTrial data={extendedFreeTrailModalData} setApiRun={setApiRun} />

			<ManageDemoAccount data={manageDemoAccountModalData} setApiRun={setApiRun} />
			<ChangePassword data={changePasswordModalData} setApiRun={setApiRun} />
			<CancelAccount data={cancelAccountModalData} setApiRun={setApiRun} />
			<ManageDemoAccountMuvi5 data={manageDemoAccountMuvi5ModalData} setApiRun={setApiRun} />
			<DeleteModal data={deleteModalData} setApiRun={setApiRun} />
			<RestoreModal data={restoreModalData} setApiRun={setApiRun} />
			<ExtendedTrailPeriodModal data={extendedTrailPeriodModalData} setApiRun={setApiRun} />
			<Subscription data={subscriptionModalData} setApiRun={setApiRun} />

			{loading ? (
				""
			) : totalCount > 0 ? (
				""
			) : (
				<tr>
					<td
						colSpan={columndata.length + 1 > 11 ? 11 : columndata.length + 1}
						style={{
							textAlign: "center",
							height: "370px",
						}}
					>
						<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_504_30600)">
								<path
									d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
									fill="#EFF6FE"
								></path>
								<path d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z" fill="white"></path>
								<path
									d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
									fill="#E2EAF3"
								></path>
								<path d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z" fill="white"></path>
								<path
									d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
									fill="#E2EAF3"
								></path>
								<path
									d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z"
									fill="#7AADF0"
								></path>
								<path
									d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
									fill="#B5DEFF"
								></path>
							</g>
							<defs>
								<clipPath id="clip0_504_30600">
									<rect width="56" height="56" fill="white"></rect>
								</clipPath>
							</defs>
						</svg>
						<div class="mt-3">No Data found</div>
					</td>
				</tr>
			)}
		</tbody>
	);
};

export default TableList;



// WEBPACK FOOTER //
// ./src/components/crm/table/TableList.jsx